import { Permissions } from './Permissions';

export class Stage {}

export class NotStarted extends Stage {}

export class OngoingFetch extends Stage {
  constructor(public key: string, public promise: Promise<Permissions>) {
    super();
  }
}

export class Fetched extends Stage {
  constructor(public key: string, public permissions: Permissions) {
    super();
  }
}
